function isObject (obj) {
  const type = typeof obj
  return type === 'object' && !!obj
}

export default function deepCopy<T> (src: T): T {
  let target
  if (Array.isArray(src)) {
    target = []
    for (let i = 0; i < src.length; i++) {
      if (isObject(src[i])) {
        target.push(deepCopy(src[i]))
      } else {
        target.push(src[i])
      }
    }
  } else {
    target = {}
    for (const prop in src) {
      if (src.hasOwnProperty(prop)) {
        if (isObject(src[prop])) {
          target[prop] = deepCopy(src[prop])
        } else {
          target[prop] = src[prop]
        }
      }
    }
  }
  return target
}

export function deepEquals (obj1, obj2) {
  if (obj1 === obj2) {
    return true
  }

  if (isPrimitive(obj1) && isPrimitive(obj2)) {
    return obj1 === obj2
  }

  if (isPrimitive(obj1) && !isPrimitive(obj2)) {
    return false
  }

  if (!isPrimitive(obj1) && isPrimitive(obj2)) {
    return false
  }

  const obj1Keys = Object.keys(obj1).filter(k => obj1[k] !== undefined)
  const obj2Keys = Object.keys(obj2).filter(k => obj2[k] !== undefined)

  if (obj1Keys.length !== obj2Keys.length) {
    return false
  }

  return obj1Keys.every(k => deepEquals(obj1[k], obj2[k]))
}

function isPrimitive (obj) {
  return (!obj || obj !== Object(obj))
}
